import { Navigate } from 'react-router-dom'

export const Users = () => {

    return <Navigate to='/tagok/mobil-app-felhasznalok' />

}
